<template>
  <el-card
    class="firstlog-detail"
    shadow="never"
    :body-style="{ padding: '20px' }"
  >
    <div slot="header" class="clearfix">
      <span style="font-size: 16px">
        请求信息
        <el-button ref="copyBtn" type="text" size="mini">复制</el-button>
      </span>
    </div>

    <div ref="body" class="request-body">
      <div class="request-line" :class="{ 'is-empty': requestline === '' }">
        {{ requestline }}
      </div>

      <div class="request-line" :class="{ 'is-empty': requestbody === '' }">
        {{ requestbody }}
      </div>

      <div class="request-line">
        =================== 响应内容 ===================
      </div>
      <div class="request-line" :class="{ 'is-empty': responseline === '' }">
        {{ responseline }}
      </div>

      <div class="request-line" :class="{ 'is-empty': responsebody === '' }">
        <highlight :value="responsebody" />
      </div>
    </div>
  </el-card>
</template>

<script>
import ClipboardJS from 'clipboard'
import highlight from '@/mixins/highlight.js'

export default {
  mixins: [highlight],
  props: {
    log: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    requestline() {
      const { path, qs, method } = this.log || {}
      return `${method} ${path}${qs ? '?' : ''}${qs || ''}`
    },

    requestbody() {
      const { requestBody } = this.log || {}

      return requestBody || ''
    },

    responseline() {
      return (this.log || {}).statusCode || ''
    },

    responsebody() {
      const { responseBody } = this.log || {}
      return responseBody || ''
    },
  },

  mounted() {
    const btn = this.$refs.copyBtn

    if (btn) {
      console.log(btn.$el)
      const clipboard = new ClipboardJS(btn.$el, {
        target: () => this.$refs.body,
      })

      clipboard.on('success', e => {
        this.$message.success('复制成功')
        e.clearSelection()
      })

      clipboard.on('error', e => {
        this.$message.warning('请按 Ctrl+C 复制文字')
      })

      this.$on('destory', () => clipboard.destroy())
    }
  },

  beforeDestroy() {
    this.$emit('destory')
  },
}
</script>

<style lang="scss" scoped>
.firstlog-detail {
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }

  .clearfix:after {
    clear: both;
  }

  .setcolor {
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }

  border: none;

  .request-body {
    padding: 5px;
    font-size: 13px;
    min-height: 300px;
    max-height: 500px;
    overflow-y: auto;
    border: 1px rgb(134, 132, 132) solid;
    border-radius: 2px;

    .request-line {
      line-height: 2;
      word-wrap: break-word;
      overflow: hidden;

      &.is-empty {
        width: 1px;
        height: 1em;
      }
    }
  }
}
</style>
